import { KeycloakPkceMethod } from "keycloak-js";
import { environment } from "src/environments/environment";

export class AuthUrls{

    private static localAuthBaseURL = "http://localhost:8081"; //local
    private static liveAuthBaseURL = "https://liristech.com:8445"; // https://79.143.188.56:8445

    private static localAuthRedirectBaseURL = "http://localhost:4200"; 
    private static liveAuthRedirectBaseURL = "https://liristech.com:4200"; //


    //public static AUTH_BASE_URL = this.localAuthBaseURL;
    //public static AUTH_BASE_URL = this.liveAuthBaseURL;
    //public static AUTH_REDIRECT_BASE_URL = this.localAuthRedirectBaseURL;
    //public static AUTH_REDIRECT_BASE_URL = this.liveAuthRedirectBaseURL;

    public static AUTH_BASE_URL: string = environment.keycloak.baseUrl;
    public static AUTH_REDIRECT_BASE_URL: string = environment.keycloak.redirectBaseUrl;
}

export class AuthConstants{

    private static localRealm = 'afcar-dev'
    private static devRealm = 'afcar-dev'
    private static prodRealm = 'afcar-prod'

    private static localClientId = 'afcar-we'
    private static devCLientId = 'afcar-we'
    private static prodClientId = 'afcar-we'

    //public static REALM = this.localRealm
    //public static CLIENT_ID = this.localClientId
    //public static PKCE_METHOD: KeycloakPkceMethod = 'S256' 

    public static REALM = environment.keycloak.realm
    public static CLIENT_ID = environment.keycloak.clientId
    public static PKCE_METHOD: KeycloakPkceMethod = 'S256' 
}
